var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"layout"}},[_c('navbar'),(!_vm.isNavbarCollapseOpen)?_c('div',[(_vm.isShowPageNotFound)?_c('PageNotFound'):_c('router-view',{key:_vm.currentKey,on:{"changeComponentKey":_vm.changeComponentKey}}),(!_vm.storeMode)?_c('app-footer'):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }